<div class="component-container lg:pr-[15rem] md:pr-[12rem] sm:pr-0 xs:pr-0">
  <div
    class="user-detail-container flex flex-col gap-[2.4rem] w-full">
    <div class="row flex flex-col justify-between items-start w-full">
      <div class="info-section block sm:hidden mt-[1rem]">
        <div class="label">
            {{ user?.type }}<span *ngIf="user?.isLar">(LAR)</span><span *ngIf="user.role === roles.adult && user?.relationWithParticipant" [class.relation-other]="user?.isOtherRelation" [title]="user?.isOtherRelation ? user?.relationWithParticipant : ''">,&nbsp;{{ user?.relationWithParticipant }}</span>&nbsp;- Age {{ user?.age }}
        </div>
      </div>
      <div class="flex md:flex-row xs:flex-col sm:flex-col justify-start items-start gap-[2%] w-full">
        <div class="quick-links-section flex flex-col md:w-[20%] min-w-[20%] xs:w-full sm:w-full">
          <div class="sub-heading">
            Quick Links
          </div>
          <div class="sub-row flex flex-wrap md:flex-col xs:flex-row sm:flex-row md:gap-[0.2rem] xs:gap-[2rem] sm:gap-[2rem]">
            <div
              (click)="link.handleClick(user?.id)"
              *ngFor="let link of links"
              class="link"
            >
              {{ link.label }}
            </div>
          </div>
        </div>

        <div
          [formGroup]="form"
          class="row flex md:flex-row w-full md:gap-[2rem] flex-col gap-[1rem] xs:mt-[1rem] sm:mt-[1rem] md:mt-[0]">
          <app-text-area-input
            (checkForErrors)="checkForErrors($event)"
            [error]="errorMessages['internalNote']"
            [parentFormGroup]="form"
            class="input w-full"
            controlName="internalNote"
            label="Internal Notes"
            placeholder="Enter internal notes about this person (optional)"
            type="small"
          ></app-text-area-input>
        </div>
      </div>
    </div>
  </div>

  <form class="schedule-details flex flex-col w-full space-y-[1rem]"><!-- lg:space-x-[1.5rem] xs:space-x-0 sm:space-x-0  -->
    <div
      class="flex lg:flex-row flex-wrap justify-between items-center lg:gap-[2%] xs:gap-[4%] sm:gap-[2%] mt-[1rem]">
      <app-date-picker
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['sessionStartDate']"
        [parentFormGroup]="form"
        class="input lg:w-[20%] xs:w-full sm:w-full"
        controlName="sessionStartDate"
        label="Session Start Date"
        placeholder="Select a date"
        type="small"
      >
      </app-date-picker>
      <app-time-picker
        (checkForErrors)="checkForErrors($event)"
        [error]="errorMessages['startTime']"
        [parentFormGroup]="form"
        class="input lg:w-[18%] xs:w-[48%] sm:w-[49%]"
        controlName="startTime"
        label="Start Time"
        placeholder="Select time"
        type="small"
      ></app-time-picker>
        <app-number-input
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['duration']"
          [max]="999"
          [parentFormGroup]="form"
          class="input lg:w-[18%] min-w-[18%] xs:w-[48%] sm:w-[49%]"
          controlName="duration"
          label="Duration"
          suffixText="Mins"
          type="small"
        ></app-number-input>
        <app-dropdown
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['sessionFormat']"
          [options]="sessionFormatOptions"
          [parentFormGroup]="form"
          class="input lg:w-[18%] min-w-[18%] xs:w-[48%] sm:w-[49%]"
          controlName="sessionFormat"
          label="Session Format"
          placeholder="Select one"
          type="small"
        />
        <app-dropdown
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['sessionDelivery']"
          [options]="sessionDeliveryOptions"
          [parentFormGroup]="form"
          class="input lg:w-[18%] min-w-[18%] xs:w-[48%] sm:w-[49%]"
          controlName="sessionDelivery"
          label="Session Delivery"
          placeholder="Select one"
          type="small"
        />
    </div>

    <div class="flex flex-col justify-start">
      <div class="label !mb-0">
        Coaches
      </div>
      <div class="coaches flex flex-wrap md:flex-row w-full xs:flex-col sm:flex-col">
        <mat-checkbox
          (change)="onCoachSelectionChange(option)"
          *ngFor="let option of coachesOptions"
          [checked]="option.checked"
          [disabled]="(isCoachSelectionDisabled && !option?.checked || sessionCompleted) || groupStatus !== 2 || sessionDetails?.participantStatus?.key === 4 || sessionDetails?.participantGroupStatus === 4"
          aria-label="Select an option"
          class="checkbox small"
        >
          {{ option.value }}
        </mat-checkbox>
        <mat-checkbox
          (change)="onSelectOtherCoaches($event)"
          [checked]="isOtherCoachSelectionEnabled"
          [disabled]="sessionCompleted ||  groupStatus !== 2 ||  sessionDetails?.participantStatus?.key === 4 || sessionDetails?.participantGroupStatus === 4"
          class="checkbox small">
          {{ 'Other' }}
        </mat-checkbox>
      </div>
    </div>
    <div
      class="other-coaches flex w-full justify-start items-center">
      <app-dropdown
        (checkForErrors)="checkForErrors($event)"
        [enableClearSelection]="true"
        [enableMultiple]="true"
        [error]="errorMessages['otherCoaches']"
        [loading]="otherCoachesOptionsLoading"
        [options]="otherCoachesOptions"
        [parentFormGroup]="form"
        class="input lg:w-[40%] xs:w-full sm:w-full mt-[1rem]"
        controlName="otherCoaches"
        label="Choose Coach"
        placeholder="Select Coaches"
        type="small"
      />
    </div>
  </form>

  <div class="flex flex-col w-full">
    <div>
      <div
        (click)="handleDownloadVisitNotesClick(user?.id)"
        class="link"
      >
        Download Encounter Summary
      </div>
      <div
        [formGroup]="form"
        class="row flex md:flex-row w-full md:gap-[2rem] flex-col gap-[1rem] mt-[1rem]">
        <app-text-area-input
          (checkForErrors)="checkForErrors($event)"
          [error]="errorMessages['visitNote']"
          [parentFormGroup]="form"
          class="input w-full extra-small"
          controlName="visitNote"
          label="Encounter Summary Notes"
          placeholder="Enter Encounter Summary notes about this session (optional)"
          type="small"
        ></app-text-area-input>
      </div>
    </div>
  </div>
</div>
